export default (data) => {
    const primaryKey = Object.keys(data)[0]

    data[primaryKey]['titleBar'] = {
        backButton: data[primaryKey].back,
        title: data[primaryKey].title
    }

    return data
}